var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareMedium = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.8 11.5a.5.5 0 01.5.5v7.2a1.3 1.3 0 001.3 1.3h10.8a1.3 1.3 0 001.3-1.3V12a.5.5 0 011 0v7.2a2.3 2.3 0 01-2.3 2.3H6.6a2.3 2.3 0 01-2.3-2.3V12a.5.5 0 01.5-.5zM11.646 2.646a.5.5 0 01.707 0l3.6 3.6a.5.5 0 11-.707.708L12 3.707 8.754 6.954a.5.5 0 11-.708-.708l3.6-3.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.5a.5.5 0 01.5.5v11.7a.5.5 0 01-1 0V3a.5.5 0 01.5-.5z"
  })));
});
export default SvgShareMedium;